import * as actions from 'modules/cameras/actions';
import * as types from 'modules/cameras/actionTypes';
import type {
  CameraScan,
  DeleteCameraAction,
  FetchCameraAction,
  FetchCameraScansAction,
  PatchCameraStatusAction,
} from 'modules/cameras/types';
import { pairTvFailureMessageId } from 'modules/cameras/utils';
import type { ApiError, ApiFailureAction, EmptyResponseBody, MetaAction } from 'modules/global/generic.types';

const UPDATE_SUCCESS_NOTIFICATION = {
  success: { id: 'page.cameras.update.success', defaultMessage: 'The camera has been updated with success.' },
  failure: { id: 'page.cameras.update.failure', defaultMessage: 'An error occurred during the camera update.' },
};

const simpleRequests = {
  [types.DELETE_REQUEST]: {
    callbacks: {
      success: (_: EmptyResponseBody, meta: MetaAction, { payload }: DeleteCameraAction) =>
        actions.deleteCameraSuccess(payload.cameraId, meta),
      failure: (error: ApiError, meta: MetaAction, { payload }: DeleteCameraAction) =>
        actions.deleteCameraFailure(error, { ...meta, entityId: payload.cameraId }),
    },
    notifications: {
      success: { id: 'page.cameras.delete.success', defaultMessage: 'The camera has been deleted with success.' },
      failure: { id: 'page.cameras.delete.failure', defaultMessage: 'An error occurred during the camera deletion.' },
    },
  },
  [types.PATCH_STATUS_REQUEST]: {
    callbacks: {
      failure: (error: ApiError, meta: MetaAction, { payload }: PatchCameraStatusAction) =>
        actions.patchCameraStatusFailure(error, { ...meta, entityId: payload.cameraId }),
    },
    notifications: UPDATE_SUCCESS_NOTIFICATION,
  },
  [types.PUT_CAMERA]: {
    notifications: UPDATE_SUCCESS_NOTIFICATION,
  },
  [types.POST_CAMERA]: {
    notifications: {
      success: { id: 'page.cameras.create.success', defaultMessage: 'The camera has been created with success.' },
      failure: { id: 'page.cameras.create.failure', defaultMessage: 'An error occurred during the cameras creation.' },
    },
  },
  [types.FETCH_CAMERA]: {
    callbacks: {
      failure: (error: ApiError, meta: MetaAction, { payload }: FetchCameraAction) =>
        actions.fetchCameraFailure(error, { ...meta, entityId: payload.cameraId }),
    },
  },
  [types.FETCH_CAMERAS]: {},
  [types.FETCH_CAMERA_SCANS]: {
    callbacks: {
      success: (data: Array<CameraScan>, meta: MetaAction, { payload }: FetchCameraScansAction) =>
        actions.fetchCameraScansSuccess(data, payload.cameraId, meta),
    },
  },
  [types.POST_CAMERA_TV_PAIRING]: {
    notifications: {
      success: { id: 'page.cameras.pair.success', defaultMessage: 'The TV has been paired successfully.' },
      failure: (failureAction: ApiFailureAction) => ({ id: pairTvFailureMessageId(failureAction) }),
    },
  },
  [types.POST_CAMERA_TV_UNPAIRING]: {
    notifications: {
      success: { id: 'page.cameras.unpair.success', defaultMessage: 'The TV has been unpaired successfully.' },
      failure: { id: 'page.cameras.unpair.failure', defaultMessage: 'An error occurred during the unpairing.' },
    },
  },
};

export default simpleRequests;
